import React, { useState, useEffect } from 'react';
import { PagingQuery } from 'tea-component';
import { useHistory , useIntl } from 'umi';
import SortBy, {
  SortByItemType,
} from '@/pages/intelligence/components/TableComponents/components/SortBy';
import FirstRow from '@/pages/intelligence/components/TableComponents/components/FirstRow';
import { TopchartTableProps } from '@/pages/intelligence/pages/_config/topchartsInterface';

import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import {
  TableCheckboxHeader,
  TableCheckboxRender,
} from '@/pages/intelligence/components/TableComponents/components/TableCheckbox';
import { getCountryFlag } from '@/pages/home/_config/countries';
import TopchartTable from '@/pages/intelligence/components/TableComponents/TopchartTable';
import { /* PHeatColumn, CountryColumn, */CommonMetricColumn } from '../columns';
import { useMobileOptionList } from '@/pages/intelligence/pages/TopCharts/_hooks/useMobileOptionList';
// import { getImg } from '@/pages/home/_config/getImgs';
import {
  GenreHeader,
  GenreRender,
} from '@/pages/intelligence/components/TableComponents/components/TableGenre';
import { getDetailGameOverviewPath } from '@/pages/intelligence/utils/topchartsUtils';
import { DetailsCloums } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/CommonCloums';
import { getPlatformIconsImg } from '@intelligence/utils/common';
import { getGameRankDetails } from '@intelligence/utils/tableUtils';

interface NewReleaseTableProps extends TopchartTableProps {
  entityType: string;
}

export default function NewReleasePCConsoleTable(props: NewReleaseTableProps) {
  const {
    entityType,
    loading,
    records = [],
    tableTotal,
    pageSortAttr,
    onTableSortChage,
    onTablePagingChange,
    tableSelection,
    tableSelectionAll,
    onTableCheckGame,
  } = props;
  const {
    potentialSteamNewAndTrending,
    potentialXboxNewRelease,
    potentialSourceSteamPCU,
    potentialNewGamesNewRelease,
  } = useMobileOptionList();
  const { formatMessage } = useIntl(); // 中英切换方法
  const { tablePageIndex, tablePageSize, currentSortValue, currentSortMetric } =
    pageSortAttr || {};
  const history = useHistory();
  const defaultPageSize = 100;
  const [pageIndex, setPageIndex] = useState(tablePageIndex || 1);
  const [pageSize, setPageSize] = useState(tablePageSize || defaultPageSize);
  const [selectList, setSelectList] = useState(tableSelection);

  useEffect(() => {
    setSelectList(tableSelection);
  }, [tableSelection]);

  useEffect(() => {
    setPageIndex(tablePageIndex);
    setPageSize(tablePageSize);
  }, [tablePageIndex, tablePageSize]);

  const onPagingChange = (e: PagingQuery) => {
    setPageIndex(e.pageIndex || 1);
    setPageSize(e.pageSize || defaultPageSize);
    onTablePagingChange(e);
  };

  const onSortChage = (e: SortByItemType) => {
    onTableSortChage(e);
  };

  const getMetricCloums = () => {
    const metricCloums: any[] = [];
    // DAU Revenue Download 每个数据源赋值一遍
    const titles = [];
    if (entityType === 'pc') {
      titles.push(potentialSourceSteamPCU);
      titles.push(potentialSteamNewAndTrending);
    } else {
      titles.push(...[potentialXboxNewRelease, potentialNewGamesNewRelease]);
    }
    titles.forEach((t) => {
      metricCloums.push(
        CommonMetricColumn({
          ...t,
          currentSortValue,
          currentSortKey: `${currentSortMetric}`,
          onSortChage,
          entityType,
          showCompareBubble: true,
        }),
      );
    });
    return metricCloums;
  };
  const onClickGame = (gameId: string) => {
    history.push(getDetailGameOverviewPath(gameId, entityType));
  };

  return (
    <>
      {/* 如果没有排序 header-other 用个类名 有排序用这个 table-header */}
      {/* sub-table-fixed 子表格固定的类名 组件库修改 全局通用 */}
      <TopchartTable
        recordKey="app_id"
        loading={loading}
        records={records}
        tableTotal={tableTotal}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onPagingChange={onPagingChange}
        columns={[
          {
            key: 'select',
            width: 36,
            fixed: 'left',
            header: () => (
              <TableCheckboxHeader
                selectList={selectList}
                tableSelectionAll={tableSelectionAll}
                disabled={loading || records?.length === 0}
                onChange={(list, stats) => {
                  onTableCheckGame(list, stats);
                  setSelectList(list);
                }}
              />
            ),
            render: (cvm: any) => (
              <TableCheckboxRender
                selectList={selectList}
                cvm={{ ...(cvm || {}), gameId: cvm?.app_id }}
                disabled={getGameRankDetails(cvm?.rank).isDisabled}
                onChange={(list, status) => {
                  setSelectList(list);
                  onTableCheckGame(list, status);
                }}
              />
            ),
          },
          {
            key: 'gametitle',
            header: (
              <div className="dbi-firstRow-flex">
                <div className="dbi-text-id">#</div>
                <div>{formatMessage({ id: 'dbi_top_gametitle' })}</div>
              </div>
            ),
            width: 330,
            fixed: 'left',
            render: (cvm: any) => {
              const icons = getPlatformIconsImg(cvm?.platform);
              return (
                <FirstRow
                  id={getGameRankDetails(cvm?.rank)?.rankText}
                  cvm={{
                    imgType: entityType,
                    img: cvm?.cover,
                    gametitle: cvm?.name,
                    countryIcon: getCountryFlag(cvm?.publisher_addr),
                    text: cvm?.publisher,
                    icon: entityType === 'pc' ? null : icons,
                  }}
                  rihgtClickToJumpHref={getDetailGameOverviewPath(cvm?.app_id, entityType)}
                  onClick={() => {
                    onClickGame(cvm?.app_id);
                  }}
                />
              );
            },
          },
          // CountryColumn({ width: 150 }),
          // PHeatColumn({
          //   currentSortKey: currentSortMetric,
          //   currentSortValue: currentSortValue,
          //   onSortChage,
          // }),
          ...getMetricCloums(),
          {
            key: 'release_time',
            align: 'center',
            width: 170,
            header: (
              <CloumsCenter width={170} align="left">
                <SortBy
                  align="left"
                  title={formatMessage({ id: 'dbi_release_date' })}
                  defaultKey={currentSortMetric}
                  defaultValue={currentSortValue}
                  list={[
                    {
                      key: `release_time_0`,
                      sortMetric: 'release_time',
                      text: formatMessage({ id: 'dbi_release_date' }),
                      title: formatMessage({ id: 'dbi_release_date' }),
                    },
                  ]}
                  onChange={onSortChage}
                />
              </CloumsCenter>
            ),
            render: (cvm: any) => (
              <CloumsCenter width={170} align="left">
                {cvm.release_time}
              </CloumsCenter>
            ),
          },
          {
            key: 'genre',
            header: (
              <div className="header-other">
                <GenreHeader genreSource={''} />
              </div>
            ),
            width: 220,
            align: 'left',
            render: (cvm: any) => (
              <GenreRender
                mainGenre={cvm?.genre || '-'}
                subGenre={cvm?.sub_genre || '-'}
              />
            ),
          },
          DetailsCloums({
            onClickGame: (cvm: any) => {
              onClickGame(cvm?.app_id);
            },
            formatMessage,
          }),
        ]}
      />
    </>
  );
}
